import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { ChangeEvent } from "react";
import Field from "./Field";
import { FormErrors, IPersonalDetails } from "./types";

type PersonalDetailsProps = {
  onNext: () => void;
  handlePersonalDetails: (event: ChangeEvent<HTMLInputElement>) => void;
  personalDetails: IPersonalDetails;
  errors: FormErrors;
};

const PersonalDetails = ({
  onNext,
  handlePersonalDetails,
  personalDetails,
  errors,
}: PersonalDetailsProps) => (
  <form
    noValidate
    className="flex flex-col gap-4"
    onSubmit={(event) => {
      event.preventDefault();
      onNext();
    }}
  >
    <h2 className="text-2xl font-semibold text-gray-900 sm:text-3xl">
      About you
    </h2>
    <Field
      id="fullName"
      label="Full name"
      required
      autoComplete="name"
      value={personalDetails.fullName}
      onChange={handlePersonalDetails}
      error={errors.fullName}
    />
    <Field
      id="email"
      label="Email"
      type="email"
      required
      autoComplete="email"
      value={personalDetails.email}
      onChange={handlePersonalDetails}
      error={errors.email}
    />
    <Field
      id="phone"
      label="Phone number"
      type="tel"
      required
      autoComplete="tel"
      placeholder="+44 20 7946 0000"
      value={personalDetails.phone}
      onChange={handlePersonalDetails}
      error={errors.phone}
    />
    <Field
      id="location"
      label="Where are you based?"
      required
      autoComplete="address-level2"
      value={personalDetails.location}
      onChange={handlePersonalDetails}
      error={errors.location}
    />
    <Field
      id="lastCompany"
      label="Current or last company"
      autoComplete="organization"
      value={personalDetails.lastCompany}
      onChange={handlePersonalDetails}
      error={errors.lastCompany}
    />
    <button
      type="submit"
      className="mt-2 flex items-center justify-center gap-3 self-stretch rounded-lg bg-orange-500 px-4 py-3 font-medium text-white hover:bg-orange-600 sm:self-end"
    >
      Next
      <ArrowRightIcon className="h-5 w-5" aria-hidden="true" />
    </button>
  </form>
);

export default PersonalDetails;
